// quantity-bundle.js — fonte da verdade: variantes do produto
// Cada radio guarda o variant.id como value e expõe preços em data-attributes.

class QuantityBundle {
  constructor(container) {
    this.container = container;

    this.productId = container.dataset.productId;
    this.productHandle = container.dataset.productHandle;

    this.options = [...container.querySelectorAll(".quantity-bundle__option")];
    this.radioButtons = container.querySelectorAll(
      ".quantity-bundle__radio-input",
    );

    this.buyButton = container.querySelector(".quantity-bundle__buy-button");
    this.unitPriceEl = container.querySelector(".quantity-bundle__price-unit");
    this.comparePriceEl = container.querySelector(
      ".quantity-bundle__compare-price",
    );
    this.currentPriceEl = container.querySelector(
      ".quantity-bundle__current-price",
    );
    this.pixPriceEl = container.querySelector(".quantity-bundle__pix-price");
    this.parcelsPriceEl = container.querySelector(
      ".quantity-bundle__price-parcels",
    );
    this.tagDiscountEl = container.querySelector(
      ".quantity-bundle__discount-tag",
    );

    this.parcelas =
      parseFloat(this.parcelsPriceEl && this.parcelsPriceEl.dataset.parcelas) ||
      1;
    this.pixDiscount =
      parseFloat(this.pixPriceEl && this.pixPriceEl.dataset.pixDiscount) || 0;
    this.pixSuffix = this.extractPixSuffix();

    this.selectedVariantId = container.dataset.variantId;
    this.selectedQuantity = 1;
    this.selectedTotal = 0;

    this.init();
  }

  init() {
    this.bindEvents();
    this.updateFromSelected();
    this.setupButton();
  }

  setupButton() {
    if (!this.buyButton) return;
    this.originalButtonText = this.buyButton.textContent;
  }

  extractPixSuffix() {
    if (!this.pixPriceEl) return "";
    const raw = (this.pixPriceEl.textContent || "").trim();
    // Remove o primeiro "R$ XX,YY" e mantém o sufixo (ex: "no PIX")
    return raw.replace(/^R\$\s*[\d.,]+\s*/, "").trim();
  }

  bindEvents() {
    this.radioButtons.forEach((radio) => {
      radio.addEventListener("change", () => this.updateFromSelected());
    });

    this.options.forEach((option) => {
      option.addEventListener("click", (e) => {
        if (e.target && e.target.type === "radio") return;
        const radio = option.querySelector(".quantity-bundle__radio-input");
        if (radio && !radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event("change"));
        }
      });
    });

    if (this.buyButton) {
      this.buyButton.addEventListener("click", (e) => {
        e.preventDefault();
        this.addToCart();
      });
    }
  }

  getSelectedOption() {
    const checked = this.container.querySelector(
      ".quantity-bundle__radio-input:checked",
    );
    if (checked) return checked.closest(".quantity-bundle__option");
    return this.options[0] || null;
  }

  updateFromSelected() {
    const option = this.getSelectedOption();
    if (!option) return;

    const variantId = option.dataset.variantId;
    const quantity = parseInt(option.dataset.quantity, 10) || 1;
    const priceCents = parseFloat(option.dataset.price) || 0;
    const compareCentsRaw = parseFloat(option.dataset.comparePrice);
    const compareCents =
      isFinite(compareCentsRaw) && compareCentsRaw > 0
        ? compareCentsRaw
        : priceCents;

    const total = priceCents / 100;
    const compare = compareCents / 100;
    const discountPercent =
      compare > 0 ? Math.round(((compare - total) / compare) * 100) : 0;

    this.selectedVariantId = variantId;
    this.selectedQuantity = quantity;
    this.selectedTotal = total;

    if (variantId) this.container.dataset.variantId = variantId;

    const unitPrice = quantity > 0 ? total / quantity : total;
    const pixPrice = total * ((100 - this.pixDiscount) / 100);
    const parcelaValue = this.parcelas > 0 ? total / this.parcelas : total;

    if (this.currentPriceEl)
      this.currentPriceEl.textContent = this.formatPrice(total);
    if (this.unitPriceEl)
      this.unitPriceEl.textContent = `${this.formatPrice(unitPrice)} cada`;
    if (this.parcelsPriceEl)
      this.parcelsPriceEl.textContent = `ou ${
        this.parcelas
      }x de ${this.formatPrice(parcelaValue)}`;
    if (this.pixPriceEl) {
      this.pixPriceEl.innerHTML = `${this.formatPrice(pixPrice)} ${
        this.pixSuffix
      }`.trim();
    }
    if (this.tagDiscountEl)
      this.tagDiscountEl.textContent = `${discountPercent}% OFF`;

    if (discountPercent <= 0) {
      if (this.comparePriceEl) this.comparePriceEl.style.display = "none";
      if (this.tagDiscountEl) this.tagDiscountEl.style.display = "none";
    } else {
      if (this.comparePriceEl) {
        this.comparePriceEl.style.display = "";
        this.comparePriceEl.textContent = this.formatPrice(compare);
      }
      if (this.tagDiscountEl) this.tagDiscountEl.style.display = "";
    }

    this.updateVisualSelection();
  }

  updateVisualSelection() {
    this.options.forEach((opt) =>
      opt.classList.remove("quantity-bundle__option--selected"),
    );
    const selected = this.getSelectedOption();
    if (selected) selected.classList.add("quantity-bundle__option--selected");
  }

  formatPrice(price) {
    return "R$ " + price.toFixed(2).replace(".", ",");
  }

  async addToCart() {
    if (!this.buyButton || this.buyButton.disabled) return;
    if (!this.selectedVariantId) return;

    try {
      this.buyButton.disabled = true;
      this.buyButton.textContent = "Adicionando...";

      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: this.selectedVariantId,
          quantity: 1,
        }),
      });

      if (!response.ok) throw new Error("Erro ao adicionar ao carrinho");

      this.showSuccessFeedback();
      setTimeout(() => this.openCartDrawer(), 300);
    } catch (err) {
      console.error(err);
      this.showErrorFeedback();
    }
  }

  showSuccessFeedback() {
    this.buyButton.textContent = "✓ Adicionado!";
    setTimeout(() => this.restoreButton(), 2000);
  }

  showErrorFeedback() {
    this.buyButton.textContent = "Erro - tente novamente";
    setTimeout(() => this.restoreButton(), 2500);
  }

  restoreButton() {
    this.buyButton.disabled = false;
    this.buyButton.textContent = this.originalButtonText;
  }

  async openCartDrawer() {
    try {
      const response = await fetch("/?sections=cart-drawer,cart-icon-bubble");
      const sections = await response.json();
      const parsedState = { sections };

      const drawer = document.querySelector("cart-drawer");
      if (!drawer) return;

      drawer.classList.remove("is-empty");
      drawer.renderContents(parsedState);

      requestAnimationFrame(() => {
        drawer.classList.add("animate", "active");
        document.body.classList.add("overflow-hidden");
      });
    } catch (err) {
      console.error(err);
    }
  }
}

// AUTO INIT
function initQuantityBundles(root) {
  const scope = root || document;
  scope.querySelectorAll(".quantity-bundle").forEach((bundle) => {
    if (bundle._qbInitialized) return;
    bundle._qbInitialized = true;
    new QuantityBundle(bundle);
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => initQuantityBundles());
} else {
  initQuantityBundles();
}

document.addEventListener("shopify:section:load", (e) => {
  initQuantityBundles(e.target);
});
